<!--
 * @Description: Description
 * @Author: dpw
 * @Date: 2025-01-216 11:46:23
 * @LastEditors: liyunfei 3090384495@qq.com
 * @LastEditTime: 2025-10-23 16:38:03
-->
<template>
    <div :class="['page-view', $i18n.locale]"> 
        <div class="navbar">
            <el-dropdown placement="bottom" class="custom-dropdown" @command="onCommand" trigger="click">
                <span class="el-dropdown-language">{{ currentLanguage }} </span>
                <el-dropdown-menu slot="dropdown" class="custom-dropdown-menu">
                    <el-dropdown-item :command="item.label" v-for="(item, index) in languages" :key="index"
                        :disabled="item.label === currentLanguage">{{ item.label }}
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
        <div class="titel-view">
            {{$t('login.boundTitle')}}
        </div>
        
        <div class="center-view">
            <div class="title">
                 {{$t('login.boundCenterTitle1')}}
            </div>
            <div class="tips">
                {{$t('login.boundCenterTips1')}}
            </div>

            <div class="line"></div>

            <div class="title">
                {{$t('login.boundCenterTitle2')}}
            </div>
            <div class="tips">
                 {{$t('login.boundCenterTips2')}}
            </div>

        </div>

        <div class="button-1" @click="registerClick()">
            {{$t('login.boundButton1',{item: loginType})}}
        </div>

        <div class="button-2" @click="bindClick()">
            <div class="button-name">
                {{$t('login.boundButton2')}}
            </div>
        </div>

        <div class="bottom-tips">
            <div>
                {{$t('login.boundCenterTips5',{item: loginType})}}
            </div>
            <div>
                {{$t('login.boundCenterTips6')}}
            </div>
        </div>

    
    </div>
</template>

<script> 
import { languageConfig, languageConfigM60 } from '@/assets/js/langObject' 
import { isM60 } from '@/types/device.js'

export default {
    components: {
       
    },
    data() {
        return {
            currentLanguage: '',
            languages: isM60() ? languageConfigM60 : languageConfig,
        }
    },

    computed: {
        loginType() {
            const thirdLoginInfo = JSON.parse(window.localStorage.getItem('thirdLoginInfo')) 
            let type = "Google"
            if(thirdLoginInfo){
               if(thirdLoginInfo.type === 1){
                   type = "Google"
               }else if(thirdLoginInfo.type === 2) {
                   type = "Facebook"
               }
            }
            return type
        },
    },

    watch: { 
    },

    beforeDestroy() {
      
    },
    created() { 
        // 默认语言配置
        const lang = localStorage.getItem('lang')
        if (!lang) {
            localStorage.setItem('lang', 'en-US')
        }
        console.log(`语言配置${JSON.stringify(languageConfig)}`)
        this.codeText = this.$t('login.formList[0].placeholder')
        this.areaCode = this.languages.find((item) => item.value === this.$i18n.locale)?.no
        this.currentLanguage = this.languages.find((item) => item.value === this.$i18n.locale)?.label
    },
    mounted() {
         
    },

    methods: { 
        onCommand(lang) { 
            let languageInfo = {}
            for (let index = 0; index < this.languages.length; index++) {
                if (lang === this.languages[index].label) {
                    languageInfo = this.languages[index] 
                    break
                }
            }
            this.$i18n.locale = languageInfo.value
            this.areaCode = languageInfo?.no
            localStorage.setItem('lang', this.$i18n.locale)
            this.currentLanguage = lang 
        },
        bindClick() {
           // 绑定老用户
            this.$router.push({
                path: '/bindMember',
                query: { redirect: this.$route.query.redirect || '/exception/report' }
            });
        },
        registerClick() {
           // 注册新用户
           const thirdLoginInfo = JSON.parse(window.localStorage.getItem('thirdLoginInfo'))
           if(!thirdLoginInfo) return  
           const userInfo = JSON.stringify({
                phone: thirdLoginInfo.mobile,
                code: '',
                email: thirdLoginInfo.identifier,
                countDownTime: this.countDownTime,
                areaCode: '',
                thirdCode: thirdLoginInfo.code,
                thirdEmail: thirdLoginInfo.identifier,
                thirdName: thirdLoginInfo.nickname,
                thirdPicture: thirdLoginInfo.picture,
                type: thirdLoginInfo.type,
                userId: thirdLoginInfo.userId,
            })
            window.localStorage.setItem('lookUserInfo', userInfo)
            console.log(`开始存储 ${userInfo}`)
            if(!thirdLoginInfo.identifier || thirdLoginInfo.identifier.length === 0){
                this.$router.push({
                        path: '/bindEmail',
                        query: { 
                            redirect: localStorage.getItem('redirect') || '/exception/report',
                            type: 'complete'
                        }  // 'to.fullPath'跳转到登录之前页面的路径
                    });
                return
            }else {
                this.$router.push({
                    path: '/register',
                    query: { 
                        redirect: localStorage.getItem('redirect') || '/exception/report',
                        type: 'thirdRegister'
                    }  // 'to.fullPath'跳转到登录之前页面的路径
                });
            }
           
        }
        
    }
}
</script>

<style scoped lang="less">
 .page-view {
    flex: 1;
    width: 100%;
    height: 100%;
    padding-top: 15px;
    background-image: linear-gradient(180deg, #262849, #07090f);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    // justify-content: space-between;
    justify-content: initial;
    overflow: scroll;

    .navbar {
        width: 100%;
        height: 30px;
        padding-right: 45px;
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .back {
            font-size: 12px;
            padding-left: 21px;
            color: #fff;
        }

        /deep/ .van-icon-arrow-left:before {
            font-size: 14px;
            color: #fff;
        }
    }

    .el-dropdown-language {
        font-size: 12px;
        color: #fff;

        &::after {
            content: '';
            position: absolute;
            top: 55%;
            right: -14px;
            transform: translateY(-80%);
            width: 0;
            height: 0;
            border-left: 4px solid transparent;
            border-right: 4px solid transparent;
            border-top: 4px solid #fff;
        }
    }
    .titel-view {
        display: flex;
        width: 345px;
        justify-content: center;
        align-items: center;
        font-size: 20px;
        color: #fff;
        margin-top: 69px;
        padding: 0 30px 0 30px;
    }
    .center-view{
        display: flex;
        width: 345px;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        border-radius: 8px;
        background-color: #303C5C;
        padding: 16px;
        margin-top: 56px;
        .title {
            font-size: 14px;
            background: linear-gradient(90deg,#00e3c9 0%, #009fe8 100%);
            -webkit-background-clip: text; /* 兼容 WebKit 浏览器 */
            background-clip: text;
            color: transparent; /* 关键：隐藏原文字颜色 */
        }
        .tips {
            font-size: 12px;
            color: rgba(255, 255, 255, 0.5);
            margin-top: 8px;
        }
        .line {
            width: 100%;
            height: 1px;
            background-color: rgba(255, 255, 255, 0.1);
            margin-top: 16px;
            margin-bottom: 16px;
        }
    }
    .button-1 {
       display: flex;
       width: 345px;
       height: 40px;
       justify-content: center;
       align-items: center;
       color: #222222;
       font-size: 16px;
       border-radius: 5px;
       margin-top: 112px;
        background-image: -webkit-gradient(linear, left top, right top, from(#00e3c9), to(#009fe8));
        background-image: -webkit-linear-gradient(left, #00e3c9, #009fe8);
        background-image: -o-linear-gradient(left, #00e3c9, #009fe8);
        background-image: linear-gradient(to right, #00e3c9, #009fe8);
    }

    .button-2 {
       display: flex;
        width: 345px;
        height: 39.7px;
        justify-content: center;
        align-items: center;
        color: #fff;
        font-size: 16px; 
        margin-top: 16px;
        background: url(../../assets/images/login/button-bg.png) no-repeat center center / cover;
        .button-name {
            font-size: 14px;
            background: linear-gradient(90deg,#00e3c9 0%, #009fe8 100%);
            -webkit-background-clip: text; /* 兼容 WebKit 浏览器 */
            background-clip: text;
            color: transparent; /* 关键：隐藏原文字颜色 */
        }
    }
    .bottom-tips {
        font-size: 12px;
        color: rgba(255, 255, 255, 0.5);
        margin-top: 8px; 
    }
     
 }
</style>
<style>
/deep/.register-page {
    background-image: linear-gradient(180deg, #262849, #07090f) !important;
}

input[type='number'] {
    -moz-appearance: textfield;
}

input:-webkit-autofill {
    box-shadow: 0 0 0 1000px #303c5c inset;
    -webkit-text-fill-color: #fff;
}

input:-internal-autofill-previewed,
input:-internal-autofill-selected {
    -webkit-text-fill-color: #303c5c;
    transition: background-color 5000s ease-out 0.5s;
}

::-webkit-input-placeholder {
    color: #6c6c6f;
}

::-moz-placeholder {
    /* Firefox 19+ */
    color: #6c6c6f;
}

:-ms-input-placeholder {
    /* IE 10+ */
    color: #6c6c6f;
}

:-moz-placeholder {
    color: #6c6c6f;
}
</style>
